import type { SVGProps } from 'react';
import { colors } from '@anyroad/theme';
import * as icons from './icons';

export type IconProps = SVGProps<SVGSVGElement> & {
  dataTestId?: string;
  fill?: string;
  id?: string;
  name: keyof typeof icons;
};

export const Icon = ({
  dataTestId = 'icon',
  fill = colors.text.icon,
  name,
  ...rest
}: IconProps) => {
  const Component = icons[name];

  if (!Component) {
    throw new Error(`Icon ${name} does not exist`);
  }

  return <Component data-testid={dataTestId} fill={fill} {...rest} />;
};
